import React from "react";
import { Table, Space, Button } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  SaveOutlined,
  CloseOutlined,
  EyeOutlined,
  ApartmentOutlined,
} from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import PermissionRender from "../../../components/PermissionRender";

export const SectionTable = ({
  sections,
  loading,
  onEdit,
  onDelete,
  editingEntity,
  onSave,
  onCancel,
  onView,
  isEditing,
}) => {
  const columns = [
    {
      title: "Nom",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
    },
    {
      title: "Nombre de Rues",
      dataIndex: "streetCount",
      key: "streetCount",
      render: (_, record) => record.streets.length,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          {editingEntity?.id === record.id ? (
            <>
              <Button type="primary" icon={<SaveOutlined />} onClick={onSave}>
                Enregistrer les modifications
              </Button>
              <Button danger icon={<CloseOutlined />} onClick={onCancel}>
                Annuler
              </Button>
            </>
          ) : (
            <>
              <Button
                icon={<EyeOutlined />}
                onClick={() => onView(record)}
                disabled={isEditing}
              ></Button>
              <PermissionRender requiredPermission={["sections", "update"]}>
                <Button
                  icon={<EditOutlined />}
                  onClick={() => onEdit(record)}
                  disabled={isEditing}
                ></Button>
              </PermissionRender>
              <PermissionRender requiredPermission={["sections", "view"]}>
                <NavLink
                  to={`/sections/${record.id}/streets`}
                  disabled={isEditing}
                >
                  <Button icon={<ApartmentOutlined />}>{/* Sections */}</Button>
                </NavLink>
              </PermissionRender>
              {/* <Button
                danger
                icon={<DeleteOutlined />}
                onClick={() => onDelete(record.id)}
              ></Button> */}
            </>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={sections}
      rowKey="id"
      loading={loading}
      pagination={{ pageSize: 5 }}
    />
  );
};
